<fe-header style="z-index: 10000"></fe-header>
<fe-href-subheader [breadcrumbs]="breadcrumbs"></fe-href-subheader>
<main class="mb-26 mb-sm-20">
    <div class="banner d-flex justify-content-center">
        <img
            [src]="'images/alamo-standard-of-care-600.png' | cdn"
            alt="standard of care icon"
        />
    </div>
    <section class="soc">
        <div class="soc__container container-xl">
            <div class="soc__container__info py-4 my-4 px-2 px-sm-4 px-md-0">
                <p>{{ 'fe_standard_of_care_text_first' | translate }}</p>
                <p>{{ 'fe_standard_of_care_text_second' | translate }}</p>
                <p>{{ 'fe_standard_of_care_text_third' | translate }}</p>
                <p>{{ 'fe_standard_of_care_text_fourth' | translate }}</p>
            </div>
            <div
                class="soc__container__care d-flex flex-column flex-md-row align-items-center align-items-md-start"
            >
                <img
                    [src]="'images/alamo-complete-clean-pledge-600.png' | cdn"
                    alt="complete clean ico"
                />
                <div class="d-block pt-md-4 px-2 px-sm-8 px-md-0">
                    <h2 class="pt-md-4">
                        {{ 'fe_standard_of_care_icon_title_first' | translate }}
                    </h2>
                    <p>
                        {{ 'fe_standard_of_care_icon_text_first' | translate }}
                    </p>
                </div>
            </div>
            <div
                class="soc__container__care d-flex flex-column flex-md-row align-items-center align-items-md-start"
            >
                <img
                    [src]="
                        'images/alamo-standard-of-care-low-touch-transactions-600.png'
                            | cdn
                    "
                    alt="low touch transactions icon"
                />
                <div class="d-block pt-md-4 px-2 px-sm-8 px-md-0">
                    <h2 class="pt-md-4">
                        {{
                            'fe_standard_of_care_icon_title_second' | translate
                        }}
                    </h2>
                    <p>
                        {{ 'fe_standard_of_care_icon_text_second' | translate }}
                    </p>
                </div>
            </div>
            <div
                class="soc__container__care d-flex flex-column flex-md-row align-items-center align-items-md-start"
            >
                <img
                    [src]="
                        'images/alamo-standard-of-care-exceptional-customer-service-600.png'
                            | cdn
                    "
                    alt="exceptional costumer service icon"
                />
                <div class="d-block pt-md-4 px-2 px-sm-8 px-md-0">
                    <h2 class="pt-md-4">
                        {{ 'fe_standard_of_care_icon_title_third' | translate }}
                    </h2>
                    <p>
                        {{ 'fe_standard_of_care_icon_text_third' | translate }}
                    </p>
                </div>
            </div>
            <div
                class="soc__container__care d-flex flex-column flex-md-row align-items-center align-items-md-start"
            >
                <img
                    [src]="
                        'images/alamo-standard-of-care-fully-maintained-vehicles-600.png'
                            | cdn
                    "
                    alt="fully maintained vehicles icon"
                />
                <div class="d-block pt-md-4 px-2 px-sm-8 px-md-0">
                    <h2 class="pt-md-4">
                        {{
                            'fe_standard_of_care_icon_title_fourth' | translate
                        }}
                    </h2>
                    <p>
                        {{ 'fe_standard_of_care_icon_text_fourth' | translate }}
                    </p>
                </div>
            </div>
            <div
                class="soc__container__care d-flex flex-column flex-md-row align-items-center align-items-md-start"
            >
                <img
                    [src]="
                        'images/alamo-standard-of-care-visual-inspection-600.png'
                            | cdn
                    "
                    alt="visual inspection icon"
                />
                <div class="d-block pt-md-4 px-2 px-sm-8 px-md-0">
                    <h2 class="pt-md-4">
                        {{ 'fe_standard_of_care_icon_title_fifth' | translate }}
                    </h2>
                    <p>
                        {{ 'fe_standard_of_care_icon_text_fifth' | translate }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</main>
<fe-footer></fe-footer>
